import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ApiService } from 'src/app/shared/services/api.service';


@Component({
  selector: 'app-register-project',
  templateUrl: './register-project.component.html',
  styleUrls: ['./register-project.component.css']
})
export class RegisterProjectComponent {
  projectForm: FormGroup;
  isSubmitted = false;

  constructor(private fb: FormBuilder, private apiService: ApiService) {
    this.projectForm = this.fb.group({
      name: ['', [Validators.required, Validators.minLength(3)]],
      description: ['', Validators.required],
      startDate: ['', Validators.required],
      endDate: ['', Validators.required],
      budget: ['', [Validators.required, Validators.pattern("^[0-9]*$")]]
    });
  }

  submitForm() {
    this.isSubmitted = true;
    if (this.projectForm.valid) {
      this.apiService.registerProject(this.projectForm.value).subscribe(
        (res) => {
          alert('Project Registered Successfully!');
          this.projectForm.reset();
          this.isSubmitted = false;
        },
        (err) => alert(`Error: ${err.error.message}`)
      );
    }
  }
}
